const inicialState = {
  conclusaoFinalizada: false,  
};

export default inicialState;



// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/conclusao/conclusao.state.js